import { render, staticRenderFns } from "./Newsleter.vue?vue&type=template&id=994ef1ba&"
import script from "./Newsleter.vue?vue&type=script&lang=js&"
export * from "./Newsleter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports